import { FormControl } from '@angular/forms';
import angular from 'angular';
import { Subscription } from 'rxjs';

FavoriteCreationController.$inject = ['$scope', '$mdDialog', '$translate', 'favorite', 'dropdownItems', 'routingTagExists', 'company', 'FavoritesFactory', 'StrategiesFactory',
  'BusinessChatFactory', 'TwitterFactory', 'FacebookFactory', 'WhatsappFactory', 'KakaotalkFactory', 'Instagram2Factory', 'SiteFilterHelperFactory'];
export function FavoriteCreationController($scope, $mdDialog, $translate, favorite, dropdownItems, routingTagExists, company, FavoritesFactory, StrategiesFactory,
  BusinessChatFactory, TwitterFactory, FacebookFactory, WhatsappFactory, KakaotalkFactory, Instagram2Factory, SiteFilterHelperFactory) {

  $scope.ok = ok;
  $scope.cancel = cancel;

  $scope.findTagItems = tag => FavoritesFactory.findTagItems($scope, tag);
  $scope.filterChannelDropdown = filterChannelDropdown;
  $scope.siteChannels = [];
  $scope.subscriptions = new Subscription();

  init();

  function init() {
    $scope.company = company;
    $scope.site = { id: 0 };  // SiteId to denote all sites. Needed for attachments in editor2
    $scope.langTag = company.tags_groups.find(tg => tg.tag_index === 0);

    $scope.fav = angular.copy(favorite);
    if (!$scope.fav.temporaryProperties) {
      $scope.fav.temporaryProperties = {};
    }

    _initFavoriteRestrictionsFormControls();

    $scope.fav.temporaryProperties.text = $scope.fav.editorModel?.text || '';
    $scope.dropdownItems = angular.copy(dropdownItems);
    $scope.dropdownItems.itemsMap = new Map(dropdownItems.itemsMap); // angular.copy doesnt copy Map content.

    $scope.allChannels = angular.copy($scope.dropdownItems.channels); // Store them for filtering based on selected sites
    $scope.publicTwitterChannels = TwitterFactory.getAllTasksTypes().filter(ch => !TwitterFactory.taskTypeIsPrivate(ch));

    $scope.routingTagExists = routingTagExists;

    // Labels
    $scope.labels = {
      sites: $translate.instant('metrics/account'),
      channels: $translate.instant('metrics/task_type'),
      teams: $translate.instant('task/mt/team'),
    };

    $scope.editorLangCodes =
      ['fr', 'en', 'de', 'es', 'it'].reduce((result, language) => {
        result[language] = $translate.instant(language);
        return result;
      }, {});

    $scope.findLangCode = lang => {
      for (const [key, value] of Object.entries($scope.editorLangCodes)) {
        if (value === lang) {
          return key;
        }
      }
    };

    $scope.editorInitialModel = $scope.fav.editorModel || {};
    $scope.editorModelAccessor = {};

    buildEditorConf($scope.fav.channels);

    filterChannelDropdown();
  }

  function _initFavoriteRestrictionsFormControls() {
    $scope.fav.temporaryProperties.tagControls = {};
    $scope.fav.temporaryProperties.sitesCtrl = new FormControl(
      SiteFilterHelperFactory.convertSiteAndSiteGroupsToKey($scope.fav.sites, $scope.fav.siteGroupIds)
    );
    $scope.fav.temporaryProperties.channelsCtrl = new FormControl($scope.fav.channels);
    $scope.fav.temporaryProperties.teamsCtrl = new FormControl($scope.fav.teams);

    $scope.fav.tags.forEach(tag => {
      $scope.fav.temporaryProperties.tagControls[tag.label] = new FormControl(tag.values);
      $scope.subscriptions.add($scope.fav.temporaryProperties.tagControls[tag.label].valueChanges.subscribe(values => tag.values = values));
    });

    $scope.subscriptions.add(
      $scope.fav.temporaryProperties.sitesCtrl.valueChanges.subscribe(values => {
        const { siteIds, siteGroupIds } = SiteFilterHelperFactory.extractSitesAndSiteGroupsByKey(values)
        $scope.fav.sites = siteIds;
        $scope.fav.siteGroupIds = siteGroupIds;
      })
    );
    $scope.subscriptions.add($scope.fav.temporaryProperties.channelsCtrl.valueChanges.subscribe(values => $scope.fav.channels = values));
    $scope.subscriptions.add($scope.fav.temporaryProperties.teamsCtrl.valueChanges.subscribe(values => $scope.fav.teams = values));
  }

  function ok() {
    $scope.fav.editorModel = $scope.editorModelAccessor.getText()[0];
    if (!$scope.fav.temporaryProperties) {
      $scope.fav.temporaryProperties = {};
    }
    $scope.fav.temporaryProperties.text = $scope.fav.editorModel?.text || '';

    // Make sure the selected channels are allowed
    if ($scope.availableChannels && $scope.availableChannels.size) {
      $scope.fav.channels = $scope.fav.channels.filter(ch => $scope.availableChannels.has(ch));
    }

    // By default favorite will be created for sites on which the user has AUTOMATION right
    if (!$scope.fav.sites.length && !$scope.fav.siteGroupIds?.length) {
      $scope.dropdownItems.sites.forEach(site => {
        if (site.isGroup) {
          if (!$scope.fav.siteGroupIds) {
            $scope.fav.siteGroupIds = []
          }
          $scope.fav.siteGroupIds.push(site.id);
        } else {
          $scope.fav.sites.push(site.id);
        }
      });
    }

    $mdDialog.hide($scope.fav);
  }

  function cancel() {
    $mdDialog.cancel();
  }

  // Filters the channel dropdown list - called each time site selection is changed
  function filterChannelDropdown() {
    $scope.siteChannels = []; // Clear channels corresponding to previous sites

    // Build available channels for selected sites
    SiteFilterHelperFactory.convertSiteAndSiteGroupsToKey($scope.fav.sites, $scope.fav.siteGroupIds)
      .forEach(key => {
        const result = $scope.dropdownItems.itemsMap.get(key);
        if (result) {
          const { type } = result;
          for (let strategy of StrategiesFactory.getAll()) {
            if (type === strategy.getType()) {
              $scope.siteChannels.push(strategy.getAllTasksTypes().map(taskType => taskType));
              break;
            }
          }
        }
      });
    $scope.availableChannels = new Set($scope.siteChannels.flatten());  // Flatten and remove duplicates
    if ($scope.availableChannels?.size) {
      $scope.dropdownItems.channels = $scope.allChannels.filter(ch => ch.subitems.map(obj => obj.id).some(id => $scope.availableChannels.has(id)));
    } else {
      $scope.dropdownItems.channels = $scope.allChannels; // Means the user has not selected any sites, so all channels are available
    }
    // Pass only the channels that are eligible for the editor configuration (and appear in the channel dropdown)
    const channelFromAccounts = $scope.fav.channels.filter(ch => $scope.availableChannels.has(ch));
    buildEditorConf(channelFromAccounts?.length ? channelFromAccounts : $scope.fav.channels);
  }

  function clearAllEditorButText() {
    let text = $scope.editorModelAccessor.getText().map(item => item.text).join('\n');
    text = text.replace(/@\[user\] /g, ''); // Remove user mentions if any
    text = text.replace(/\[user\] /g, '');

    $scope.editorInitialModel = {
      'text': text
    };
  }

  /**
   * TODO once #4550 (MR!142) is merged the max chars should be based on factory.getQuickRepliesElementsConfig
   */
  function setMaxMsgLength(channels) {
    var channelsAndSites = ($scope.siteChannels || []).filter(cc => !cc.some(c => new Set(channels).has(c))).concat(channels).flatten();
    if (channelsAndSites.length) {
      // Selected channels include twitter public
      if (channelsAndSites.some(ch => $scope.publicTwitterChannels.includes(ch))) {
        $scope.hasTwitterMentionMaxLengthLimitation = true;
        return 280;
      }
      // Selected channels include kakaotalk or instagram private.
      var kakaotalkChannels = KakaotalkFactory.getAllTasksTypes();
      if (channelsAndSites.some(ch => Instagram2Factory.taskTypeIsPrivate(ch) || kakaotalkChannels.includes(ch))) {
        return 1000;
      }
      // Selected channels include facebook private.
      if (channelsAndSites.some(ch => FacebookFactory.taskTypeIsPrivate(ch))) {
        return 2000;
      }
      // Selected channels include Whatsapp.
      if (channelsAndSites.some(ch => WhatsappFactory.getAllTasksTypes().includes(ch))) {
        return 4096;
      }
      return 0;
    }
    $scope.hasTwitterMentionMaxLengthLimitation = true;
    return 280;
  }


  /**
   * pictureEnabled : always true
   * videoEnabled : true iff all channels are either FB private or BZC (private)
   * bzcRichLinkEnabled : only if all selected channels are ABC channels 
   * showInsertMentionButton : only if all selected channels are facebook channels (excluding event comments & private)
   * username : the text that is shown inside the textarea in place of the mention btn
   * showAddDMLinkButton : only if all selected channels are twitter channels (excluding private)
   * useTwitterTextLib : only if selected channels include twitter channels with message length limit
   * maxLength : only if selected channels include public twitter channel or facebook private channel
   * lang : pass the first lang tag of the favorite if found in the list of available ones otherwise use 'fr' as default
   */
  function buildEditorConf(channels) {
    $scope.hasTwitterMentionMaxLengthLimitation = false;

    $scope.editorConfiguration = {
      'pictureEnabled': true,
      'imageMimeTypes': 'image/*',
      'videoMimeTypes': 'video/*',
      'videoEnabled': channels.length > 0 && channels.every(ch => FacebookFactory.taskTypeIsPrivate(ch)
        || BusinessChatFactory.taskTypeIsPrivate(ch)
        || WhatsappFactory.taskTypeIsPrivate(ch)),
      'fileEnabled': channels.length > 0 && channels.every(ch => FacebookFactory.taskTypeIsPrivate(ch)
        || BusinessChatFactory.taskTypeIsPrivate(ch)
        || WhatsappFactory.taskTypeIsPrivate(ch)),
      'bzcRichLinkEnabled': angular.equals(channels, BusinessChatFactory.getAllTasksTypes()),
      'showInsertMentionButton': channels.length > 0 && channels.every(ch => FacebookFactory.taskTypeCanHaveMentionBtn(ch)),
      'username': '[user]',
      'showAddDMLinkButton': channels.length > 0 && channels.every(ch => TwitterFactory.taskTypeHasMentionFilter(ch)),
      'maxCharsNumber': setMaxMsgLength(channels),
      'useTwitterTextLib': channels.some(ch => $scope.publicTwitterChannels.includes(ch)),
      'lang': $scope.findLangCode($scope.fav.tags.find(tag => tag.id === $scope.langTag.id).valueList[0]) || 'fr'
    }
  }

  // Build a new editor conf on channel change
  $scope.$watch('fav.channels', (newValue, oldValue) => {
    if (newValue !== oldValue) {
      buildEditorConf(newValue);
    }
  }, true);

  // Watch for changes to bzcRichLinkEnabled, showInsertMentionButton, showAddDMLinkButton, maxCharsNumber
  // and re-init the editor, keeping only the text
  $scope.$watch('editorConfiguration', (newValue, oldValue) => {
    if (newValue !== oldValue) {
      clearAllEditorButText();
    }
  }, true);

  $scope.$on('$destroy', function () {
    $scope.subscriptions?.unsubscribe();
  });

}
